module.exports = __webpack_public_path__ + "img/GRT正.dd9bbe0a.jpg";